// APP更新管理
export const GETLIST = 'GETLIST'
